import React, { Component } from 'react';
import Helmet from 'react-helmet';
import ReactSVG from "react-svg";
import Link from "../Link/Link.jsx";
import "../../styles/style.css";

function importSvgs(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}

const svgs = importSvgs(require.context("../../svgs", true, /\.svg$/))
const dark = "#313131";
const light = "#f8f8f8";

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            darkMode: false
        }

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        this.setState(prevState => ({
            darkMode: !prevState.darkMode
        }));
    }

    render(){
        return(
            <div>
                <Helmet
                    bodyAttributes={this.state.darkMode ? {style: 'background-color : #313131'} :
                        {style: 'background-color: #f8f8f8'}}/>
                <div 
                    className="name" 
                    style={this.state.darkMode ? {color: light} : {color:dark}}>
                    Daniel Chain
                </div>
                <div className="h-centered">
                    <span>
                        <Link
                            url="https://linkedin.com/in/danielchain3/"
                            name="LinkedIn"
                            svg={svgs["linkedin.svg"]}
                            darkMode={this.state.darkMode}
                        />
                        <Link
                            url="https://github.com/danielchain3"
                            name="GitHub"
                            svg={svgs["github.svg"]}
                            darkMode={this.state.darkMode}
                        />
                        <Link
                            url="mailto:danielchain3@gmail.com"
                            name="Email"
                            svg={svgs["mail.svg"]}
                            darkMode={this.state.darkMode}
                        />
                    </span>
                </div>
                <div className="h-centered">
                    <ReactSVG 
                        src={svgs["ward-icon.svg"]}
                        evalScripts="always"
                        fallback="Ward"
                        svgClassName="glow"          
                        svgStyle={{width:100}}
                        onClick={() => {this.handleClick()}}
                    />
                </div>
            </div>
        )
    }
}

export default App;
